import { useNavigate } from 'react-router';
import { Colour, Tag, TagSizeEnum } from '@ukpostbox/frontend-framework';
import { MailTagType } from '../Types/MailTagTypes';
import { useMailboxesStore } from '../../../Providers/Stores/MailboxesStore';

function MailTag(props: MailTagType) {
	const navigate = useNavigate();

	const mailBoxInfo = useMailboxesStore((state) => state.mailBoxInfo);

	return (
		<Tag
			id={props.id}
			name={props.name}
			size={props.small ? TagSizeEnum.Small : TagSizeEnum.Medium}
			onClickCallback={
				mailBoxInfo.mailTagIds !== props.id
					? (e) => {
							e.preventDefault();
							navigate(`/mail/search?mailTagIds=${props.id}`);
						}
					: undefined
			}
			colour={mailBoxInfo.mailTagIds === props.id ? Colour.Success : Colour.Primary}
			removeCallback={props.removeCallback ? () => props.removeCallback(props.id) : undefined}
			hideIcon={props.hideIcon}
		/>
	);
}

export { MailTag };
